<template>
  <div class="index" :class="{ collapse: isCollapse }">
    <el-container>
      <el-aside>
        <div class="aside-title">
          <div class="title-content">
            {{ shopOrStudioTag === "工作室" ? "管理后台" : "商家中心" }}
          </div>
        </div>
        <el-menu
          class="el-menu-vertical-demo"
          background-color="#202e56"
          text-color="#fff"
          active-text-color="#fff"
          :collapse="isCollapse"
          :collapse-transition="false"
          :default-active="currentActiveMenuPath"
          :default-openeds="defaultOpeneds"
          @select="handleSelect"
        >
          <div
            v-for="(menu, index) in menuList"
            :index="String(index)"
            :key="index"
          >
            <el-submenu v-if="!menu.path" :index="String(index)">
              <template slot="title">
                <i class="iconfont" :class="menu.icon"></i>
                <span>{{ menu.title }}</span>
              </template>
              <el-menu-item
                v-for="childMenu in menu.children"
                :key="childMenu.title"
                :index="childMenu.path"
                @click="to(childMenu.path)"
                >{{ childMenu.title }}</el-menu-item
              >
            </el-submenu>
            <el-menu-item :index="menu.path" v-else @click="to(menu.path)">
              <i class="iconfont" :class="menu.icon"></i>
              <span class="menu-name">{{ menu.title }}</span>
            </el-menu-item>
          </div>
        </el-menu>
      </el-aside>
      <el-container>
        <!--头部-->
        <el-header>
          <div class="header-left-box">
            <div class="toggle-collapse-btn" @click="toggleAside">
              <i
                :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
              ></i>
            </div>
            <!--店铺名称-->
            <span class="shop-title">{{
              this.$store.state.user.userInfo.shopName
            }}</span>
          </div>

          <div class="header-right-box">
            <el-dropdown>
              <div class="el-dropdown-link">
                <div class="user-info">
                  <img
                    :src="
                      $store.state.user.userInfo.avatar ||
                      'https://zxxkstatic.zxxk.com/uc/images/userface/00001.jpg?v248443'
                    "
                    alt=""
                    class="user-photo"
                  />
                  <span class="user-name">{{
                    $store.state.user.userInfo.userName
                  }}</span
                  ><i class="el-icon-arrow-down el-icon--right"></i>
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-user-solid">
                  <el-button
                    @click="to('/info/user/info')"
                    type="text"
                    size="small"
                    >个人信息</el-button
                  ></el-dropdown-item
                >
                <el-dropdown-item icon="el-icon-switch-button">
                  <el-button @click="logout()" type="text" size="small"
                    >退出登录</el-button
                  ></el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!--          <i class="el-icon-bell" style="cursor: pointer"></i>-->
          <div class="message-icon-btn" @click="goUserCenter">
            <el-badge
              :value="messageBoxNum"
              :hidden="messageBoxNum === 0"
              class="item"
            >
              <i class="el-icon-bell"></i>
            </el-badge>
          </div>
          <!-- 访问店铺弹窗 -->
          <div class="to-store-btn" @click="showViewStoreDialog = true">
            访问{{ shopOrStudioTag }}
          </div>

          <!-- 年度账单按钮 -->
          <div
            v-if="showAnnualReportBtn"
            class="annual-report-btn"
            @click="showAnnualReportDialog = true"
          ></div>
        </el-header>
        <!--主体部分-->
        <el-main>
          <!--面包屑-->
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
    <!-- 年度账单弹窗 -->
    <AnnualReportDialog
      v-if="showAnnualReportDialog"
      @closeDialog="showAnnualReportDialog = false"
    />
    <!-- 访问店铺弹窗 -->
    <ViewStoreDialog
      v-if="showViewStoreDialog"
      @closeDialog="showViewStoreDialog = false"
    ></ViewStoreDialog>
  </div>
</template>
<script>
import api from "@/assets/js/api";
import store from "@/store/index";
import shopCenterConst from "@/assets/js/shopCenterConst";
import AnnualReportDialog from "../components/annual-report/2024-annual-report-dialog.vue";
import ViewStoreDialog from "../components/view-store/view-store-dialog.vue";
export default {
  components: {
    AnnualReportDialog,
    ViewStoreDialog,
  },
  data() {
    return {
      messageBoxNum: 0,
      isCollapse: false,
      userinfo: "",
      showAnnualReportBtn: false, // 是否显示年度报告弹窗按钮
      showAnnualReportDialog: false, // 是否显示年度报告弹窗
      showViewStoreDialog: false, // 是否显示访问店铺弹窗
      menuList: [
        {
          title: `${this.$store.getters["user/shopOrStudioTag"]}总览`,
          icon: "icon-a-16",
          permissionCode: "1",
          path: "/shop/info",
        },
        {
          title: "内容管理",
          icon: "icon-a-17",
          permissionCode: "1",
          children: [
            {
              title: "资料管理",
              permissionCode: "2",
              path: "/resource/document/list",
            },
            {
              title: "专辑管理",
              permissionCode: "2",
              path: "/resource/album/list",
            },
            {
              title: "视频管理",
              permissionCode: "2",
              path: "/resource/video/list",
            },
            {
              title: "文章管理",
              permissionCode: "2",
              path: "/resource/article/list",
            },
          ],
        },
        {
          title: "交易管理",
          icon: "icon-a-18",
          permissionCode: "1",
          children: [
            {
              title: "资产管理",
              permissionCode: "2",
              path: "/trade/fund",
            },
          ],
        },
        {
          title: "营销工具",
          icon: "icon-yingxiaogongju",
          permissionCode: "1",
          children: [
            {
              title: "限时折扣",
              permissionCode: "2",
              path: "/marketing/discount",
            },
          ],
        },
        {
          title: "数据分析",
          icon: "icon-a-19",
          permissionCode: "1",
          children: [
            {
              icon: "el-icon-goods",
              title: "流量数据",
              permissionCode: "1",
              path: "/resource/traffic-data",
            },
            {
              icon: "el-icon-goods",
              title: "内容数据",
              permissionCode: "1",
              path: "/resource/data",
            },
            {
              icon: "el-icon-goods",
              title: "交易数据",
              permissionCode: "1",
              path: "/resource/trade-data",
            },
            {
              icon: "el-icon-goods",
              title: "用户数据",
              permissionCode: "1",
              path: "/resource/user-data",
            },
          ],
        },
        {
          title: "创作学院",
          icon: "icon-chuangzuoxueyuan",
          permissionCode: "1",
          path: "/tutorial/index",
        },
        {
          title: `${this.$store.getters["user/shopOrStudioTag"]}管理`,
          icon: "icon-a-20",
          permissionCode: "1",
          children: [
            {
              icon: "el-icon-goods",
              title: `${this.$store.getters["user/shopOrStudioTag"]}认证`,
              permissionCode: "2",
              path: "/authentication/shop-authentication",
            },
            {
              icon: "el-icon-goods",
              title: `${this.$store.getters["user/shopOrStudioTag"]}装修`,
              permissionCode: "2",
              path: "/info/shop/shop-decoration-index",
            },
            {
              icon: "el-icon-goods",
              title: `${this.$store.getters["user/shopOrStudioTag"]}信息`,
              permissionCode: "2",
              path: "/info/shop/info",
            },
          ],
        },
      ],
      defaultOpeneds: [], // 默认打开的菜单
    };
  },
  created() {
    this.getMessageBoxNum();
  },
  mounted() {
    // 默认打开的菜单
    this.defaultOpeneds = this.menuList.map((item, index) => {
      return String(index);
    });
    // 判断年度报告弹窗是否显示
    this.setAnnualReportDialogVisible();
  },
  computed: {
    userTypeId() {
      return this.$store.state.user.userInfo.userTypeId;
    },
    shopTypeId() {
      return this.$store.state.user.userInfo.shopTypeId;
    },
    // 店铺或工作室
    shopOrStudioTag() {
      return this.$store.getters["user/shopOrStudioTag"];
    },
  },
  watch: {
    userTypeId: {
      immediate: true,
      handler(newVal) {
        this.updateMenu(newVal);
      },
    },
    shopTypeId: {
      immediate: true,
      handler(newVal) {
        this.updateMenuByShopType(newVal);
      },
    },
  },
  methods: {
    goUserCenter() {
      window.open("https://user.zxxk.com/usermessage/index.html");
      window.focus();
    },
    getMessageBoxNum() {
      let _that = this;
      this.$axios.get(api.info.getMessageBoxCount).then((res) => {
        _that.messageBoxNum = res.result;
      });
    },
    // 判断是否在年度报告时间段内 并判断年度报告弹窗是否显示
    setAnnualReportDialogVisible() {
      // 判断当前日期是否在年度报告弹窗显示时间范围内 2025-01-01 ~ 2025-01-31
      const nowDate = new Date();
      const startDate = new Date("2025-01-01 00:00:00");
      // const startDate = new Date("2024-12-25 00:00:00");
      const endDate = new Date("2025-01-31 12:00:00");
      // 在时间段内
      if (nowDate >= startDate && nowDate <= endDate) {
        // 每个用户显示一次
        if (this.$store.state.user.userInfo.userId) {
          // 显示弹窗按钮
          this.showAnnualReportBtn = true;
          // 判断当前用户是否已经显示过年度报告弹窗
          const key = "shopIsShow-" + this.$store.state.user.userInfo.userId;
          const isShow = localStorage.getItem(key);
          // 决定是否自动显示弹窗
          this.showAnnualReportDialog = !isShow;
        }
      } else {
        // console.log("不在年度报告弹窗显示时间范围内");
        this.showAnnualReportBtn = false;
        return;
      }
    },
    updateMenu(userTypeId) {
      if (
        userTypeId === shopCenterConst.role.boss ||
        userTypeId === shopCenterConst.role.manager
      ) {
        const key = `${this.$store.getters["user/shopOrStudioTag"]}管理`;
        const employeeMenu = {
          title: `${key === "店铺管理" ? "店员信息" : "成员信息"}`,
          permissionCode: "1",
          path: "/info/shop/employee-list",
        };
        const shopManagementMenu = this.menuList.find(
          (item) => item.permissionCode === "1" && item.title === key
        );
        if (shopManagementMenu) {
          shopManagementMenu.children.push(employeeMenu);
        }
      }
    },
    updateMenuByShopType(shopTypeId) {
      // 工作室
      if (shopTypeId === 65) {
        this.menuList = this.menuList.filter(
          (item) => item.title !== "营销工具" && item.title !== "创作学院"
        );
      }
    },
    to(url) {
      this.$router.push(url);
    },
    handleSelect(key) {
      this.$store.commit("setActiveIndex", key);
    },
    toggleAside() {
      this.isCollapse = !this.isCollapse;
    },
    async logout() {
      await this.$axios.get(api.user.logout);
      window.location.href = store.state.system.logoutSSOUrl;
    },
    goShopMain() {
      window.open(
        "https://shop.xkw.com/" + this.$store.state.user.userInfo.shopId
      );
    },
  },
};
</script>
<style lang="scss">
::-webkit-scrollbar {
  width: 0; /* 增加滚动条的宽度 */
}
$aside-width: 225px;
$aside-collapse-width: 65px;
$header-height: 46px;
$footer-height: 0px;
$aside-bg-color: #202e56;
.shop-title {
  margin-left: 20px;
  font-weight: 600;
}
header.el-header {
  height: $header-height !important;
  line-height: $header-height;
  color: #333;
  padding-left: $aside-width;
  transition: all 0.3s;
  box-shadow: 0 0 0 1px #333;
}

.aside-title {
  height: 60px;
  line-height: 60px;
  background-color: $aside-bg-color;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}

.el-aside {
  background-color: $aside-bg-color;
  text-align: center;
  line-height: 200px;
  width: $aside-width !important;
  position: absolute;
  left: 0;
  bottom: 0;
  top: 0;
  transition: all 0.3s;
  z-index: 99;
}

div.collapse {
  .el-aside {
    width: $aside-collapse-width !important;
    z-index: 9;
  }
  .title-content,
  .el-submenu__title span {
    display: none;
  }
  .el-header {
    padding-left: $aside-collapse-width;
  }
  .el-main {
    margin-left: $aside-collapse-width;
  }
}

.el-main {
  background-color: #e9eef3;
  margin-left: $aside-width;
  transition: all 0.3s;
  height: calc(100vh - #{$header-height} - #{$footer-height});
}

ul.el-menu {
  border-right: 0;
}
.el-menu--inline {
  padding-left: 32px !important;
}
.el-menu-item {
  i {
    margin-right: 10px;
    font-size: 18px;
  }
}
.el-submenu__title {
  i {
    margin-right: 10px;
    font-size: 18px;
  }
}
.el-menu-item:hover,
.el-submenu__title:hover,
.el-menu-item.is-active {
  background-color: #5a83ff !important;
  color: #fff !important;
  i {
    color: #fff !important;
  }
}

.header-left-box {
  float: left;
}

.header-right-box {
  float: right;
}
.header-right-box .user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.header-right-box .user-info .user-photo {
  width: 28px;
  height: 28px;
  margin-right: 5px;
  border-radius: 28px;
  border: 1px solid #e5e5e5;
}
.header-right-box .user-info .user-name {
  color: #606266;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}
.toggle-collapse-btn {
  font-size: 18px;
  margin-left: 15px;
  cursor: pointer;
  color: #5a83ff;
  margin-left: 20px;
  float: left;
}
.user-show {
  margin-left: 20px;
  float: left;
}
.user-logout {
  cursor: pointer;
}

.el-form-item {
  margin-bottom: 11px !important;
}
.query-conditions {
  padding-top: 11px !important;
}
.el-table div.cell,
.el-table--border .el-table__cell:first-child .cell,
.el-table th.el-table__cell > .cell {
  padding-left: 20px;
  padding-right: 20px;
}
.annual-report-btn {
  float: right;
  margin-right: 12px;
  cursor: pointer;
  width: 170px;
  height: 28px;
  margin-top: 10px;
  background: url(../assets/images/annual-report/2024-report-btn-bg.png)
    no-repeat;
  background-size: 100% 100%;
}
.to-store-btn {
  float: right;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  margin-right: 20px;
  margin-top: 11px;
  border-radius: 30px;
  border: 1px solid #6384f7;
  color: #6384f7;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 100% */
  text-decoration: none;
  cursor: pointer;
}
.collapse .el-menu-item .menu-name {
  display: none;
}
.el-menu--collapse .el-submenu .el-submenu__title .el-icon-arrow-right {
  display: none !important;
}
// 自定义的dialog弹窗中使用的message样式
.dialog-message {
  z-index: 9999999 !important;
}
.message-icon-btn {
  float: right;
  display: inline-flex;
  padding: 5px 5px;
  margin-right: 20px;
  margin-top: 8px;
  font-size: 20px;
  font-weight: 400;
  line-height: 20px; /* 100% */
  text-decoration: none;
  cursor: pointer;
}
</style>
